import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px 0",
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto",
      padding: "20px 50px",
    },
    "& .MuiStepLabel-labelContainer": {
      width: "max-content",
    },
    "& .color": {
      color: Colors.darkSlate,
    },
    "& .connect-button": {
      border: "1px solid #E3E6EC",
      [theme.breakpoints.down("sm")]: {
        width: "176px",
      },
    },
    "& .MuiButton-label": {
      fontSize: "12px",
      textTransform:"none",
    },
    "& .activeStep1":{
      "& .MuiStepIcon-root":{
        "& circle:":{
          border:`1px solid ${Colors.green}`, 
        },
          
      },
      
    },
    "& .learnStep":{
      "& .MuiStepIcon-root.MuiStepIcon-active":{
        border: `1px solid ${Colors.green}`,
        color:Colors.white,
        "& .MuiStepIcon-text":{
          fill:"#6B8299"
        }
      }
    }
    
  },
  button: {
    marginRight: theme.spacing(1),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: "inline-block",
  },
  instructions: {
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
